import { createSlice } from "@reduxjs/toolkit"

export const categoryListSlice = createSlice({
	name: "category_list",
	initialState: {
		categories: "",
		errors: [],
	},

	reducers: {
        getCategories: (state, action) => {
            // console.log(action.payload)
			state.categories = action.payload
		},
		getCategoryList: (state, action) => {
			state.categories = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getCategories, getCategoryList, getErrors} = categoryListSlice.actions

export default categoryListSlice.reducer
